/**
 * Configuración centralizada del E-Commerce
 * Modifica estos valores según tu ambiente
 */

export const ECOMMERCE_CONFIG = {
    // API Base URL - Usa la variable existente REACT_APP_API_URL
    API_BASE_URL: process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '',
    
    // IDs por defecto
    EMPRESA_ID: parseInt(process.env.REACT_APP_EMPRESA_ID || '1'),
    SUCURSAL_ID: parseInt(process.env.REACT_APP_SUCURSAL_ID || '1'),
    
    // Usar datos mockeados si la API falla
    FALLBACK_TO_MOCK: process.env.REACT_APP_FALLBACK_TO_MOCK !== 'false',
    
    // Debug mode - mostrar logs en consola
    DEBUG: process.env.REACT_APP_DEBUG === 'true',
    
    // Timeouts
    REQUEST_TIMEOUT: 10000
};

export const ecommerceError = (message, error = null) => {
    console.error(`[ECommerce ERROR] ${message}`, error || '');
};
